import React from 'react';
import {
  buildCommissionSummary,
  getCommissionAmountForCourse
} from '../utilities/commissions';

const formatCurrency = (value) => `Bs ${Number(value || 0).toFixed(2)}`;

const UdemyCourseMetrics = ({ instructorCourses, selectedCourseId = 'all' }) => {
  const filteredCourses = selectedCourseId === 'all'
    ? instructorCourses
    : instructorCourses.filter((course) => String(course.id) === String(selectedCourseId));

  const totalStudents = filteredCourses.reduce((sum, course) => {
    const summary = getCommissionAmountForCourse(course);
    return sum + summary.estimatedStudents;
  }, 0);

  const totalCompletedStudents = filteredCourses.reduce((sum, course) => {
    const summary = getCommissionAmountForCourse(course);
    return sum + summary.completedStudents;
  }, 0);

  const totalRating = filteredCourses.reduce((sum, course) => sum + Number(course.rating || 0), 0);
  const avgRating = filteredCourses.length > 0 ? (totalRating / filteredCourses.length).toFixed(2) : '0.00';

  const commissionSummary = buildCommissionSummary(filteredCourses);
  const totalCommission = commissionSummary.reduce((sum, item) => sum + item.commissionAmount, 0);
  const totalCompletedRevenue = commissionSummary.reduce((sum, item) => sum + item.grossCompletedRevenue, 0);
  const averageCommissionRate = commissionSummary.length > 0
    ? (
        commissionSummary.reduce((sum, item) => sum + item.commissionRate, 0) /
        commissionSummary.length
      ).toFixed(0)
    : '20';

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
      <h2 className="text-xl font-bold mb-4">Metricas del curso</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        <div className="border border-gray-200 rounded-lg p-4">
          <div className="text-gray-500 text-sm mb-1">Estudiantes inscritos</div>
          <div className="text-2xl font-bold">{totalStudents.toLocaleString()}</div>
          <div className="text-green-500 text-sm mt-1">{totalCompletedStudents.toLocaleString()} finalizaron el curso</div>
        </div>
        <div className="border border-gray-200 rounded-lg p-4">
          <div className="text-gray-500 text-sm mb-1">Valoracion promedio</div>
          <div className="text-2xl font-bold">{avgRating} ★</div>
          <div className="text-gray-500 text-sm mt-1">Basado en {filteredCourses.length} cursos</div>
        </div>
        <div className="border border-gray-200 rounded-lg p-4">
          <div className="text-gray-500 text-sm mb-1">Ingresos por cursos finalizados</div>
          <div className="text-2xl font-bold">{formatCurrency(totalCompletedRevenue)}</div>
          <div className="text-gray-500 text-sm mt-1">Base para calcular comision</div>
        </div>
        <div className="border border-gray-200 rounded-lg p-4">
          <div className="text-gray-500 text-sm mb-1">Comision total del instructor</div>
          <div className="text-2xl font-bold">{formatCurrency(totalCommission)}</div>
          <div className="text-green-500 text-sm mt-1">{averageCommissionRate}% promedio aplicado</div>
        </div>
      </div>
    </div>
  );
};

export default UdemyCourseMetrics;
